import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { showNotification } from "../../utils";
import "react-notifications-component/dist/theme.css";
import "./login.css";
import logo_3 from "../../assets/icons/colored/CC_Complete_IF.svg";

function LogIn() {
  const navigate = useNavigate();
  const [documentNumber, setDocumentNumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  function handleDocumentNumberChange(event) {
    setDocumentNumber(event.target.value);
  }

  function handlePasswordChange(event) {
    setPassword(event.target.value);
  }

  function login(user) {
    var loginUrl = `${process.env.REACT_APP_API_URL}/api/v1/auth/login`;
    return fetch(loginUrl, {
      method: "POST",
      body: JSON.stringify(user),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        if (response.status === 404) {
          showNotification("Error", "Usuario no existe", "error");
        } else if (response.status === 401) {
          const errorData = await response.json(); // Convertir la respuesta a JSON
          showNotification(
            "No ha sido autorizado",
            errorData.message || "Acceso no autorizado",
            "warning"
          );
        } else if (response.status === 403) {
          const errorData = await response.json();
          showNotification(
            "Error",
            errorData.message || "El acceso ha sido restringido",
            "error"
          );
        } else if (response.status === 200) {
          return response.json();
        } else if (response.status === 429) {
          showNotification(
            "¡Aviso!",
            "Demasiados intentos, espere 15 minutos",
            "warning"
          );
        }
      })
      .then((data) => {
        if (data?.token) {
          // Asegurar que data existe antes de acceder a token
          Cookies.set("token", data.token, {
            secure: true,
            sameSite: "strict",
          });
          navigate("/dashboard");
        }
      })
      .catch(() =>
        showNotification("Error", "El correo electrónico o la contraseña no son válidos", "error")
      );
  }

  function handleSubmit(event) {
    event.preventDefault();
    var user = {
      customer_id: documentNumber,
      password: password,
    };
    login(user);
  }

  return (
    <>
      <div className="todo">
        <div className="todo-login">
          <div className="box-logo">
            <div className="frase-canadian"></div>
          </div>
          <div className="box-logoSPC">
            <div className="box-logoSPC_back">
              <img className="CC_Logo-spc" src={logo_3} alt="logo-spc.svg" />
            </div>
          </div>
          {/* <div className="box-divider">
            <img className="" src={logo_2} alt="logo-spc.svg" />
          </div> */}
          <div className="box-login">
            <form onSubmit={handleSubmit}>
              <div className="div-description">
                <h1>Bienvenido a SPC</h1>
                <h4>
                  Sistema de Programacion Canadium <br /> Tu sistema de
                  programacion de Clases
                </h4>
                <h3>Ingresa a tu Cuenta</h3>
              </div>
              <div className="div-description_nonmobile">
                <h1>Bienvenido a SPC</h1>
                <h4>
                  Sistema de Programacion Canadium <br /> Tu sistema de
                  programacion de Clases
                </h4>
              </div>
              <div className="box-dc">
                <input
                  type="text"
                  min="1"
                  className="ep-input"
                  id="documentNumber"
                  value={documentNumber}
                  placeholder="Documento de Identificación"
                  onChange={handleDocumentNumberChange}
                  required
                />
              </div>
              <div className="box-password" style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  className="ep-input"
                  id="password"
                  value={password}
                  placeholder="Contraseña"
                  onChange={handlePasswordChange}
                  required
                />
                <span
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="password-toggle"
                  tabIndex={0}
                  aria-label={
                    showPassword ? "Ocultar contraseña" : "Mostrar contraseña"
                  }
                >
                  <i
                    className={
                      showPassword ? "fa fa-eye-slash" : "fa fa-eye"
                    }
                  ></i>
                </span>
              </div>
              <button className="s-boton" type="submit">
                Iniciar sesión
              </button>
            </form>
          </div>
          <div className="box-footer">
            <p>Speaking the same language ||</p>
            <p>&nbsp;Hablemos el mismo idioma ||</p>
            <p>&nbsp;Parle la meme langue</p>
          </div>
          <div className="box-footer_mobile">
            <p> Speaking the same language </p>
            <p> Hablemos el mismo idioma </p>
            <p> Parle la meme langue </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default LogIn;
